import React from "react";

export default function VideoEmbed({ url, className = "" }) {
  if (!url) return null;
  const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([\w-]{6,})/);
  if (yt) {
    return (
      <div className={`aspect-video rounded-2xl overflow-hidden border border-white/10 ${className}`} data-testid="video-embed">
        <iframe
          src={`https://www.youtube.com/embed/${yt[1]}`}
          title="Video"
          className="w-full h-full"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <video controls src={url} className={`w-full rounded-2xl border border-white/10 bg-black ${className}`} data-testid="video-embed" />
  );
}
